'use strict';

var numeral = require("numeral");
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Enhanced number directive.
 *
 * Currently the input is always done in french local
 *
 * Possible feature attributes :
 *
 * - number-integer : force the input to integer only ( default false )
 * - allow-negative : allow negative numbers in the input ( default false )
 * - integer-count="X"  : the max number of integer chars ( default 10 )
 * - max-decimals="Y"    : the max number of decimal chars (default 10 )
 * - no-thousands-delimiter : do not add a thousand delimiter (space). usefull for exemple for years where the common pattern is YYYY and not Y YYY.
 *
 */
ngModule.directive("inputTypeNumber", function (stringUtils, numberUtils, keyCodes) {
  var decimalDelimiterKeys = [".", ","];
  var isNumberKey = function isNumberKey(keyCode) {
    return keyCode >= 48 && keyCode <= 57;
  };
  var isDecimalSeparatorChar = function isDecimalSeparatorChar(character) {
    return _.includes(decimalDelimiterKeys, character);
  };
  return {
    restrict: 'A',
    require: "ngModel",
    link: function link($scope, $el, $attrs, modelCtrl) {
      $el.addClass("input-number");
      var maxIntegerCount = 12,
        maxDecimalCount = 2,
        numberFormat = "0,0.[00]",
        // on force la langue en français, mais idealement on devrait savoir faire la saisie dans la langue utilisateur
        decimalDelimiter = ',',
        //numeral.languageData().delimiters.decimal,
        thousandsDelimiter = '',
        //numeral.languageData().delimiters.thousands,
        isIntegerInput = _.has($attrs, "numberInteger"),
        allowNegative = _.has($attrs, "allowNegative"),
        noThousandsDelimiter = _.has($attrs, "noThousandsDelimiter");
      var refreshFormat = function refreshFormat() {
        numberFormat = "";
        if (!noThousandsDelimiter) {
          numberFormat += "0,";
        }
        numberFormat += "0.[" + new Array(maxDecimalCount + 1).join("0") + "]";
      };
      refreshFormat();
      var formatValue = function formatValue(value) {
        if (_.isNumber(value)) {
          value = String(value);
        }
        if (value == null || value.length === 0) {
          return "";
        }
        var cleaned = cleanValue(value),
          splits = cleaned.split(decimalDelimiter),
          integerPart = splits[0],
          decimalPart = splits[1],
          formatted = "",
          offset = integerPart.length % 3;
        for (var i = 0; i < integerPart.length; i++) {
          if (i > 0 && i % 3 === offset) {
            if (!noThousandsDelimiter) {
              formatted += " ";
            }
          }
          formatted += integerPart[i];
        }
        if (decimalPart != null) {
          decimalPart = decimalPart.substring(0, Math.min(maxDecimalCount, decimalPart.length));
          formatted += decimalDelimiter + decimalPart;
        }
        return formatted;
      };
      var cleanValue = function cleanValue(value) {
        return numberUtils.cleanNumberString(value);
      };
      if (_.has($attrs, "integerCount")) {
        $attrs.$observe("integerCount", function (integerCount) {
          if (integerCount) {
            maxIntegerCount = parseInt(integerCount);
            refreshFormat();
            if (modelCtrl.$modelValue) {
              // a this stage, value is a numeric, need to convert it to string for formatValue
              modelCtrl.$viewValue = formatValue("" + modelCtrl.$modelValue);
            }
            modelCtrl.$render();
          }
        });
      }
      if (_.has($attrs, "maxDecimals")) {
        $attrs.$observe("maxDecimals", function (maxDecimal) {
          if (maxDecimal) {
            maxDecimalCount = parseInt(maxDecimal);
            refreshFormat();
            if (modelCtrl.$modelValue) {
              // a this stage, value is a numeric, need to convert it to string for formatValue
              modelCtrl.$viewValue = formatValue("" + modelCtrl.$modelValue);
            }
            modelCtrl.$render();
          }
        });
      }
      modelCtrl.$formatters.push(function (value) {
        return formatValue(value);
        //return value != null ? numeral(value).format(numberFormat) : "";
      });
      modelCtrl.$parsers.push(function (value) {
        if (value == null || value === "") {
          return null;
        }
        value = value.replace(/[.]/g, ","); // TODO : generify with delimiters
        var currentLangage = numeral.language();
        // impossible de changer la langue 'localement'... donc on change et on remet
        numeral.language('fr');
        try {
          return numeral().unformat(value);
        } finally {
          numeral.language(currentLangage);
        }
      });
      var sanitizeInput = function sanitizeInput() {
        var inputValue = $el.val(),
          formatted = formatValue(inputValue);
        var sanitized;
        if (formatted) {
          var currentLangage = numeral.language();

          // impossible de changer la langue 'localement'... donc on change et on remet
          numeral.language('fr');
          try {
            sanitized = numeral(formatted).format(numberFormat);
          } finally {
            numeral.language(currentLangage);
          }
        } else {
          sanitized = "";
        }
        if (sanitized !== inputValue) {
          setViewValue(sanitized);
        }
      };
      var setViewValue = function setViewValue(value) {
        var viewValue = formatValue(value);

        // TAEL-4162 $apply already : inputTypeNumber.js - on a testé $applyAsync - mais ne marche pas bien, on perd le bon positionnement du caret, qui se remet toujours à la fin
        $scope.$apply(function () {
          modelCtrl.$setViewValue(viewValue);
          modelCtrl.$render();
        });
      };
      $el.on("input", sanitizeInput);
      $el.on("blur", sanitizeInput);
      $el.on("paste", function (event) {
        var paste = event.originalEvent.clipboardData.getData("text");

        // protège le past "à virugle" sur un champs entier
        if (isIntegerInput && paste) for (var i = 0; i < decimalDelimiterKeys.length; i++) {
          if (paste.indexOf(decimalDelimiterKeys[i]) !== -1) {
            // bloque le paste
            event.preventDefault();
          }
        }
      });
      $el.on("keydown", function (event) {
        var modelValue = modelCtrl.$modelValue || 0;
        var keyCode = event.which;
        switch (keyCode) {
          // K
          case 75:
            {
              event.preventDefault();
              if (modelValue === 0) {
                modelValue = 1;
              }
              setViewValue(modelValue * 1000);
              return;
            }
          // M
          case 77:
            {
              event.preventDefault();
              if (modelValue === 0) {
                modelValue = 1;
              }
              setViewValue(modelValue * 1000000);
              return;
            }
          case keyCodes.UP:
            {
              event.preventDefault();
              if (event.shiftKey) {
                if (modelValue === 0) {
                  modelValue = 1;
                }
                setViewValue(modelValue * 10);
              } else {
                var amount = event.ctrlKey ? 100 : event.altKey ? 1000 : 1;
                setViewValue(modelValue + amount);
              }
              return;
            }
          case keyCodes.DOWN:
            {
              event.preventDefault();
              if (event.shiftKey) {
                if (modelValue === 0) {
                  modelValue = 1;
                }
                setViewValue(modelValue / 10);
              } else {
                var _amount = event.ctrlKey ? 100 : event.shiftKey ? 1000 : 1;
                setViewValue(modelValue - _amount);
              }
              return;
            }
          case keyCodes.BACKSPACE:
            {
              event.preventDefault();
              var inputValue = $el.val();
              var selection = $el.getSelection();
              if (selection.start === 0 && selection.length === 0) {
                return;
              }
              if (selection.length > 0) {
                var newValue = inputValue.substring(0, selection.start) + inputValue.substring(selection.end, inputValue.length);
                setViewValue(newValue);
                $el.caret(selection.start, selection.start);
              } else {
                var nbRemove = 1;
                var erasedChar = inputValue.substring(selection.start - 1, selection.end);
                if (erasedChar === thousandsDelimiter) {
                  nbRemove = 2;
                }
                var _newValue = inputValue.substring(0, selection.start - nbRemove) + inputValue.substring(selection.end, inputValue.length);
                setViewValue(_newValue);
                $el.caret(selection.start - nbRemove, selection.start - nbRemove);
              }
              return;
            }
          case keyCodes.DELETE:
            {
              event.preventDefault();
              var _inputValue = $el.val();
              var _selection = $el.getSelection();
              if (_selection.length > 0) {
                var _newValue2 = _inputValue.substring(0, _selection.start) + _inputValue.substring(_selection.end, _inputValue.length);
                setViewValue(_newValue2);
                $el.caret(_selection.start, _selection.start);
              } else {
                var _erasedChar = _inputValue.substring(_selection.start, _selection.end + 1);
                var _newValue3 = _inputValue.substring(0, _selection.start) + _inputValue.substring(_selection.end + 1, _inputValue.length);
                setViewValue(_newValue3);
                if (_erasedChar === thousandsDelimiter) {
                  $el.caret(_selection.start + 1, _selection.start + 1);
                } else {
                  $el.caret(_selection.start, _selection.start);
                }
              }
              return;
            }
        }
      });
      $el.on("keypress", function (event) {
        if (event.which === keyCodes.ENTER) {
          sanitizeInput();
          return;
        }
        if (event.keyCode === keyCodes.TAB) {
          return; // required for FF...
        }
        event.preventDefault();
        var pressedCharCode = event.which,
          pressedChar = String.fromCharCode(pressedCharCode),
          oldInputValue = $el.val(),
          selection = $el.getSelection(),
          newInputValue = null;
        if (isNumberKey(pressedCharCode)) {
          newInputValue = oldInputValue.substring(0, selection.start) + pressedChar + oldInputValue.substring(selection.end, oldInputValue.length);

          // assert that we're not typing more than the maximum allowed character count.
          var delimiterIdx = oldInputValue.indexOf(decimalDelimiter),
            hasDecimal = delimiterIdx > -1,
            isTypingInteger = hasDecimal ? selection.start <= delimiterIdx : true,
            cleanedValueSplits = cleanValue(newInputValue).split(decimalDelimiter);
          if (isTypingInteger) {
            var integerPart = cleanedValueSplits[0];
            if (integerPart.length > maxIntegerCount) {
              return;
            }
          } else {
            var decimalPart = cleanedValueSplits[1];
            if (decimalPart.length > maxDecimalCount) {
              return;
            }
          }
          var occurencyCount = stringUtils.countCharOccurencies(oldInputValue.substring(0, selection.start), pressedChar);
          setViewValue(newInputValue);
          var charPosition = stringUtils.xIndexOf(pressedChar, $el.val(), occurencyCount + 1) + 1;
          if (charPosition === 0) {
            charPosition = $el.val().length;
          }
          $el.caret(charPosition, charPosition);
        } else if (allowNegative && pressedChar === "-") {
          if (selection.start > 0) {
            return;
          }
          newInputValue = "-" + oldInputValue.substring(selection.end, oldInputValue.length);
          setViewValue(newInputValue);
        } else if (!isIntegerInput && isDecimalSeparatorChar(pressedChar)) {
          // decimals separator
          // already have decimal separator
          if (oldInputValue.indexOf(decimalDelimiter) > -1) {
            return;
          }

          // TODO : only act if selection end is end of input

          newInputValue = oldInputValue.substring(0, selection.start) + decimalDelimiter + oldInputValue.substring(selection.end, oldInputValue.length);
          setViewValue(newInputValue);
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form/inputTypes/inputTypeNumber.js
// module id = 2948
// module chunks = 13